import { createStore } from 'vuex'

export default createStore({
  state: {
    data: null,
    id: null,
    rs_id: null
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
